import { Calculator, HandCoins, PackageX, Receipt } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Problem = { Icon: LucideIcon; title: string; body: string };

const PROBLEMS: ReadonlyArray<Problem> = [
  {
    Icon: HandCoins,
    title: 'La vente qui ne se fait pas',
    body: "Le client n'a pas tout le budget. Sans reprise, il repart — et achète l'article ailleurs, là où on accepte son ancien.",
  },
  {
    Icon: Calculator,
    title: "L'appoint calculé à la main",
    body: 'Prix de vente moins valeur de reprise, plus ou moins le rendu monnaie… au feeling, sur un coin de table. Une erreur et la caisse ne tombe pas juste.',
  },
  {
    Icon: PackageX,
    title: "L'occasion qui dort",
    body: "L'article repris reste dans un coin, jamais remis en stock, jamais revendu. De la trésorerie qui dort.",
  },
  {
    Icon: Receipt,
    title: 'Aucune trace',
    body: "Qui a repris quoi, à quelle valeur ? Sans trace, pas de contrôle, pas de marge connue sur l'occasion.",
  },
];

export default function TrocProblemV2() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel>Le vrai problème de la reprise</SectionLabel>
        <h2 className="mt-3 max-w-3xl font-marketing-display text-[clamp(30px,4.4vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-charcoal-800">
          La reprise, à la main, <span className="underline-lime">ça coûte cher.</span>
        </h2>
        <p className="mt-4 max-w-xl font-marketing-body text-[17px] leading-[1.55] text-charcoal-600">
          Accepter un ancien article en paiement devrait débloquer la vente — pas créer des erreurs
          de caisse et du stock fantôme. Quatre frictions reviennent toujours.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PROBLEMS.map(({ Icon, title, body }) => (
            <div
              key={title}
              className="flex flex-col gap-4 border-2 border-charcoal-800 bg-paper p-6 shadow-neobrutal-4"
            >
              <span className="flex h-12 w-12 items-center justify-center border-2 border-charcoal-800 bg-white text-terracotta-500 shadow-neobrutal-2">
                <Icon className="h-[22px] w-[22px]" strokeWidth={2} aria-hidden="true" />
              </span>
              <h3 className="font-marketing-display text-[19px] font-bold leading-[1.15] tracking-[-0.01em] text-charcoal-800">
                {title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-600">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
